/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

import React from 'react'

const ErrorFallback = () => {
  return (
    <div style={{
      textAlign: 'center'
    }}>
      <h1>
        System error
      </h1>
      <h3>
        Please check back later.
      </h3>
    </div>
  )
};

export default ErrorFallback;
